/**
 * Remove static + React splash overlays in the Capacitor iOS shell only.
 * Web/PWA splash in app/layout.tsx is unchanged when this helper no-ops.
 */

import { isCapacitorIosApp } from '@/lib/auth/capacitorSignIn'
import { isAuthenticatedAppShellPath } from '@/lib/pwa/authenticatedAppShellPath'

export function shouldDismissCapacitorNativeSplash(): boolean {
  if (typeof window === 'undefined') return false
  return (
    isCapacitorIosApp() &&
    isAuthenticatedAppShellPath(window.location.pathname)
  )
}

/**
 * Tear down #pwa-splash so it cannot intercept taps (opacity-0 splash still blocks WKWebView).
 * Safe to call repeatedly; no-op outside Capacitor iOS authenticated-app routes
 * (/app-beta, /travel).
 *
 * Call only after the app shell is ready to paint — dismissing during session "loading"
 * leaves a black WKWebView because the native loading branch is opacity-0.
 */
export function dismissCapacitorNativeSplashOverlays(): void {
  if (!shouldDismissCapacitorNativeSplash()) return
  if (document.documentElement.classList.contains('capacitor-splash-dismissed')) return

  document.documentElement.classList.add('capacitor-splash-dismissed')
  document.body.classList.add('react-ready')

  const splash = document.getElementById('pwa-splash')
  if (splash) {
    splash.classList.add('hidden')
    splash.style.setProperty('display', 'none', 'important')
    splash.style.setProperty('pointer-events', 'none', 'important')
    splash.style.setProperty('visibility', 'hidden', 'important')
    splash.style.setProperty('opacity', '0', 'important')
    splash.style.setProperty('z-index', '-1', 'important')
    splash.remove()
  }

  console.log(
    '[CapacitorSplash] dismissed #pwa-splash on native authenticated-app shell'
  )
}
